import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { useAppMutation } from '../use-app-mutation.hook';

export const useDeactivate = () => {
  const { mutate: deactivateCompany, isPending } = useAppMutation([QueryKey.DEACTIVATE_COMPANY], {
    mutationFn: ({ companyId }: { companyId: string }) =>
      ApiService.patch({
        endpoint: BackendRoute.COMPANIES,
        routePath: [companyId, 'deactivate'],
      }),
  });
  return { deactivateCompany, isPending };
};
